// The Bars per line setting (music/notation/lines.ts): how many full bars a
// line of the score view holds, or Auto to fill the width.

import { BARS_PER_LINE, type BarsPerLine } from '@/music/notation/lines';
import { useStore } from '@/state/store';

const label = (choice: BarsPerLine) => (choice === 'auto' ? 'Auto' : String(choice));

/** A settings row: label left, the choices filling the rest of the line. */
export function BarsPerLineRow() {
  const barsPerLine = useStore((s) => s.barsPerLine);
  const setBarsPerLine = useStore((s) => s.setBarsPerLine);
  return (
    <div className="settings-row">
      <span className="settings-label">Bars per line</span>
      <div className="segmented" role="group" aria-label="Bars per line">
        {BARS_PER_LINE.map((choice) => (
          <button
            key={choice}
            type="button"
            className={barsPerLine === choice ? 'active' : ''}
            onClick={() => setBarsPerLine(choice)}
            aria-pressed={barsPerLine === choice}
            data-testid={`bars-per-line-${choice}`}
          >
            {label(choice)}
          </button>
        ))}
      </div>
    </div>
  );
}
